<template>
  <div class="center mw8 pa3-ns pa2" id="app">
    <router-view></router-view>
    <v-tour name="tour" :steps="steps" :callbacks="callbacks" :options="{ highlight: true }"></v-tour>
  </div>
</template>

<script>
import { content, targets, scripts } from "./util/tour-content.js";
export default {
  name: 'App',
  data() {
    let steps = content.map((text, index) => {
      let step = {
        target: targets[index],
        content: text
      };
      if (scripts[index]) step.before = scripts[index];
      return step;
    });
    return {
      steps: steps,
      callbacks: {
        onFinish: () => localStorage.tutorial = "finished",
        onSkip: () => localStorage.tutorial = "skipped",
      }
    }
  },
  mounted() {
    if(localStorage.getItem("tutorial") == null){
      this.$tours['tour'].start()
    }
    var theme = localStorage.theme
    document.documentElement.setAttribute('data-theme', theme)
  }
}
</script>
